<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Data IKM</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <Link href="/admin/indagikm">Data IKM</Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Manajemen Data Industri Kecil Menengah</h4>
                  <p class="card-title-desc mb-0">Pendataan dan Rekap Data dasar Industri Kecil Menenah.</p>
                </div>
                <div>
                  <button type="button" class="btn btn-success" @click="tambah">Tambah Baru</button>
                </div>
              </div>

              <hr>

              <data-attribut :data="indagikm" :show_filter_btn="true" @filter="filters.show = !filters.show">

                <div v-if="filters.show">
                  <div class="d-flex flex-wrap gap-2">
                    <select name="kodekbli" id="kodekbli" v-model="filters.kodekbli" class="form-select d-inline-block form-select-sm" style="width: unset;">
                      <option :value="null">=== Semua Indusri KBLI ===</option>
                      <option :value="r.kodekbli" v-for="(r, i) in kbli" v-text="`${r.kodekbli} - ${r.uraikbli}`"></option>
                    </select>
                    <select name="sentra_id" id="sentra_id" v-model="filters.sentra_id" class="form-select d-inline-block form-select-sm" style="width: unset;">
                      <option :value="null">=== Semua Sentra ===</option>
                      <option :value="r.id" v-for="(r, i) in sentra" v-text="`${r.id} - ${r.nama_sentra}`"></option>
                    </select>
                    <select name="kodeklasifikasi" id="kodeklasifikasi" v-model="filters.kodeklasifikasi" class="form-select d-inline-block form-select-sm" style="width: unset;">
                      <option :value="null">=== Semua Klasifikasi ===</option>
                      <option :value="r.kodeklasifikasi" v-for="(r, i) in klasifikasi" v-text="`${r.kodeklasifikasi} - ${r.uraiklasifikasi}`"></option>
                    </select>
                    <button class="btn btn-outline-secondary btn-sm" type="btn" @click="reset">Reset Filter</button>
                  </div>
                  <hr>
                </div>

                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead>
                      <tr>
                        <th class="text-center">No</th>
                        <th>Nama Perusahaan / Pemilik</th>
                        <th>Jenis Produk</th>
                        <th>Bentuk Badan</th>
                        <th>Alamat</th>
                        <th class="text-center">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, index) in indagikm.data" :key="index">
                        <td scope="row" class="text-center">{{ indagikm.from + index }}</td>
                        <td scope="row">
                          <div class="fw-bold" v-text="row.nama_perusahaan"></div>
                          <span v-text="row.kontak_person || '-'"></span>
                        </td>
                        <td scope="row" v-text="row.jenis_produk"></td>
                        <td scope="row" v-text="row.bentuk_badan"></td>
                        <td scope="row" v-text="[row.alamat_jalan, row.alamat_desa, row.alamat_kecamatan, row.alamat_kabupaten].filter(r => r).join(', ')"></td>
                        <td scope="row" class="text-center">
                          <a @click="edit(row)" class="p-0 btn btn-sm btn-link">Edit</a> |
                          <a @click="remove(row)" class="p-0 btn btn-sm btn-link">Hapus</a>
                        </td>
                      </tr>
                      <tr v-if="indagikm.data.length == 0">
                        <td scope="row" colspan="6" class="text-center">
                          <i>Tidak ditemukan data!</i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </data-attribut>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- container-fluid -->
  </div>

  <modal :show="form.show" @close="form.show = false" :title="(form.id ? 'Ubah' : 'Tambah') + ' IKM'"
    backdrop="static" size="xl">
    <template #default>
      <form @submit.prevent="action">

        <div class="d-flex">
          <div class="p-3 pt-0 flex-fill">
            <div class="mb-2 row">
              <label for="nama_perusahaan" class="col-sm-2 col-form-label">Nama Perusahaan</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly" :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" id="nama_perusahaan"
                  v-model="form.data.nama_perusahaan">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="kontak_person" class="col-sm-2 col-form-label">Nama Pemilik</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly" :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" id="kontak_person"
                  v-model="form.data.kontak_person">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="bentuk_badan" class="col-sm-2 col-form-label">Bentuk Badan</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly" :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" id="bentuk_badan" v-model="form.data.bentuk_badan">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="nomor_izin" class="col-sm-2 col-form-label">Nomor Izin</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly" :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" id="nomor_izin" v-model="form.data.nomor_izin">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="jenis_produk" class="col-sm-2 col-form-label">Jenis Produk</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly" :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" id="jenis_produk" v-model="form.data.jenis_produk">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="cabang_industri" class="col-sm-2 col-form-label">Cabang Industri</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly" :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" id="cabang_industri" v-model="form.data.cabang_industri">
              </div>
            </div>

            <hr>

            <div class="mb-2 row">
              <label for="klasifikasi" class="col-sm-2 col-form-label">Klasifikasi</label>
              <div class="col-sm-10">
                <select name="klasifikasi" id="klasifikasi" class="form-select" v-if="!form.readonly" v-model="form.data.kodeklasifikasi">
                  <option :value="null">Pilih Klasifikasi</option>
                  <option :value="r.kodeklasifikasi" v-for="(r, i) in klasifikasi" v-text="`${r.kodeklasifikasi} - ${r.uraiklasifikasi}`"></option>
                </select>
                <input type="text" v-if="form.readonly" :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" id="klasifikasi" :value="[form.data.kodeklasifikasi, form.data.uraiklasifikasi].filter(r => r).join(' - ')">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="sentra" class="col-sm-2 col-form-label">Sentra</label>
              <div class="col-sm-10">
                <select name="sentra" id="sentra" class="form-select" v-if="!form.readonly" v-model="form.data.sentra_id">
                  <option :value="null">Pilih Sentra</option>
                  <option :value="r.id" v-for="(r, i) in sentra" v-text="`${r.id} - ${r.nama_sentra}`"></option>
                </select>
                <input type="text" v-if="form.readonly" :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" id="sentra" :value="[form.data.sentra_id, form.data.nama_sentra].filter(r => r).join(' - ')">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="kbli" class="col-sm-2 col-form-label">KBLI</label>
              <div class="col-sm-10">
                <select name="kbli" id="kbli" class="form-select" v-if="!form.readonly" v-model="form.data.kodekbli">
                  <option :value="null">Pilih KBLI</option>
                  <option :value="r.kodekbli" v-for="(r, i) in kbli" v-text="`${r.kodekbli} - ${r.uraikbli}`"></option>
                </select>
                <input type="text" v-if="form.readonly" :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" id="kbli" :value="[form.data.kodekbli, form.data.uraikbli].filter(r => r).join(' - ')">
              </div>
            </div>

            <hr>

            <div class="mb-2 row">
              <label for="alamat_kabupaten" class="col-sm-2 col-form-label">Kabupaten</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly" :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" id="alamat_kabupaten"
                  v-model="form.data.alamat_kabupaten">
              </div>
            </div>
            <div class="mb-2 row">
              <label for="alamat_kecamatan" class="col-sm-2 col-form-label">Kecamatan</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly" :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" id="alamat_kecamatan"
                  v-model="form.data.alamat_kecamatan">
              </div>
            </div>
            <div class="mb-2 row">
              <label for="alamat_desa" class="col-sm-2 col-form-label">Desa</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly" :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" id="alamat_desa"
                  v-model="form.data.alamat_desa">
              </div>
            </div>
            <div class="mb-2 row">
              <label for="jalan" class="col-sm-2 col-form-label">Jalan</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly" :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" id="jalan"
                  v-model="form.data.alamat_jalan">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="telpfax" class="col-sm-2 col-form-label">Telp / Fax</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly" :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" id="telpfax" v-model="form.data.telpfax">
              </div>
            </div>
          </div>

          <div>
            <div class="d-grid gap-2 flex-row">
              <button type="button" v-if="form.readonly && form.id" @click="form.readonly = false" class="btn btn-outline-success">Ubah Perusahaan</button>
              <button type="submit" v-if="!form.readonly" class="btn btn-success">Simpan</button>
              <button type="button" v-if="!form.readonly && form.id" @click="form.readonly = true" class="btn btn-danger">Batal</button>
            </div>
          </div>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import Layout from '@/layout/Index'
import Modal from '@/components/Modal'
import DataAttribut from '@/components/DataAttribut'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import axios from 'axios'

export default {
  layout: Layout,
  components: { Modal, DataAttribut },
  props: {
    indagikm: Object,
    kbli: Array,
    sentra: Array,
    klasifikasi: Array
  },
  data() {
    return {
      filters: {
        show: false,
        kodekbli: null,
        sentra_id: null,
        kodeklasifikasi: null,
      },
      form: {
        show: false,
        id: null,
        readonly: true,
        data: {}
      },
      master: {
        jenis_industri: [],
        jenis_produk: []
      }
    }
  },
  watch: {
    filters: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/admin/indagikm', pickBy(this.filters), { preserveState: true })
      }, 150),
    },
  },
  mounted() {
    Object.keys(this.filters).map(key => {
      if(this.indagikm.query[key]) {
        this.filters[key] = this.indagikm.query[key];
      }
    });
  },
  methods: {
    tambah() {
      this.form.id = null;
      this.form.show = true;
      this.form.readonly = false;
      this.form.data = {};
      this.form.data.sentra_id = null;
      this.form.data.kodekbli = null;
      this.form.data.kodeklasifikasi = null;
    },
    edit({ id }) {
      this.form.id = id;
      this.form.show = true;
      this.form.readonly = true;
      axios.get('/admin/indagikm/' + id)
        .then(res => {
          this.form.data = res.data.ikm || {};
        });
    },
    action() {
      const onSuccess = () => {
        this.form.show = false;
        this.form.id = null;
        this.form.data = {};
      }
      if (this.form.id) {
        this.$inertia.put('/admin/indagikm/' + this.form.id, this.form.data, { onSuccess });
      } else {
        this.$inertia.post('/admin/indagikm', this.form.data, { onSuccess });
      }
    },
    remove(row) {
      if(confirm('Konfirmasi Proses Penghapusan?'))
      this.$inertia.delete('/admin/indagikm/' + row.id);
    },
    reset() {
      Object.keys(this.filters).map(key => {
        this.filters[key] = ['show'].includes(key) ? false: null;
      });
    },
  },
}
</script>
